var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d8b035;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.63,370.46l111.26,196.75h-124.31l-85.05-196.75h98.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.25,370.46l85.05,196.75h-341.08l85.1-196.75h170.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.95,370.46h98.1l-85.05,196.75h-124.31l111.26-196.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.69,606.53h123.82l151.24,309.49c1.81,3.84-3.34,7.24-6.14,4.06L88.69,606.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.91,606.53h343.76l-168.46,391.25c-1.21,2.96-5.54,2.96-6.74,0l-168.56-391.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.84,916.02l151.24-309.49h123.82l-268.91,313.44c-2.8,3.29-8.01-.11-6.14-3.95"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.48,274.42c157.85,8.7,186.88,35.57,194.42,194.42,8.7-157.85,35.56-186.88,194.42-194.42-157.85-8.7-186.88-35.56-194.42-194.42-8.7,157.85-35.56,186.88-194.42,194.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo4);
export default __webpack_public_path__ + "static/media/Main Logo 4.c20624420c5dbd7b350366b44c7a75fa.svg";
export { ForwardRef as ReactComponent };